// extracted by mini-css-extract-plugin
module.exports = {"badge-offline":"BadgeOffline_badge-offline__SiOiC"};